import { useHelper } from "@react-three/drei";
import { ReactElement, useEffect, useRef } from "react";
import * as THREE from "three"
// import { lightNames, LightType } from "types/three";

export const Light = ({
    type = "spot",
    scale = [1, 1, 1],
    position = [0, 0, 0],
    lookAt = [0, 0, 0],
    intensity = 0.5,
    castShadow = true,
    ...props
}: LightType): ReactElement => {

    const lightRef = useRef<any>(null);


    useEffect(() => {
        if (lightRef.current && lookAt) {
            lightRef.current.lookAt(new THREE.Vector3(...lookAt));
        }
    }, [lookAt]);

    const lightProps = {
        scale,
        position,
        intensity,
        ref: lightRef,
        ...props,
    };

    const Lights: Record<lightNames, ReactElement | null> = {
        spot: <spotLight
            castShadow
            shadow-mapSize-width={2 ** 10}
            shadow-mapSize-height={2 ** 10}
            shadow-camera-far={5000}
            shadow-camera-left={-100}
            shadow-camera-right={100}
            shadow-camera-top={100}
            shadow-bias={-0.0001}
            shadow-camera-bottom={-100}
            {...lightProps}
        />,
        ambient: <ambientLight {...lightProps} />,
        directional: <directionalLight
            castShadow
            shadow-mapSize-width={2 ** 10}
            shadow-mapSize-height={2 ** 10}
            shadow-camera-far={5000}
            shadow-camera-left={-100}
            shadow-camera-right={100}
            shadow-camera-top={100}
            shadow-bias={-0.0001}
            shadow-camera-bottom={-100}
            {...lightProps}
        />,
        point: <pointLight
            castShadow
            shadow-mapSize-width={2 ** 8}
            shadow-mapSize-height={2 ** 8}
            shadow-camera-far={5000}
            shadow-camera-left={-100}
            shadow-camera-right={100}
            shadow-camera-top={100}
            shadow-bias={-0.0001}
            shadow-camera-bottom={-100}
            {...lightProps}
        />,
    };
    return <>
        {props.showHelper && type !== "ambient" && <Helper lightRef={lightRef} type={type} />}
        {Lights[type] ?? null}
    </>;
};



const Helper = ({ lightRef, type }: { lightRef: React.RefObject<THREE.Light>, type: "spot" | "directional" | "point" }) => {

    const Helpers = {
        spot: THREE.SpotLightHelper,
        directional: THREE.DirectionalLightHelper,
        point: THREE.PointLightHelper,
    };

    useHelper(lightRef as React.MutableRefObject<THREE.Object3D>, Helpers[type]);


    return null;
};

